module.exports = __webpack_public_path__ + "static/background-990612d66aef838fa9ba9a990a1dfcb8.png";